import { useContext } from "react";
import { ErrorActions, ErrorContextDispatch } from "components/Errors/ErrorContext";


export function useErrorActions(): ErrorActions {
    return useContext(ErrorContextDispatch)!;
};

export default useErrorActions;
